import P from 'bluebird';
import Base, { env, goLocal } from './base';

// const withPersonSmall = 'person,person.attributes,person.attributes.attribute';
// const withPersonEmail = 'person.emails,person.emails.type';
// const withPersonDocuments = 'person.documents,person.documents.type';
// const withPersonTelephones = 'person.telephones,person.telephones.type';
// const withPersonAddress =
//   'person.addresses,person.addresses.state,person.addresses.country,person.addresses.city,person.addresses.type';
// const withDevices = 'person.devices,person.devices.type';
// const withPerson = `${withPersonSmall},${withDevices},${withPersonTelephones},${withPersonDocuments},${withPersonEmail}`;
// const withAccount =
//   'accounts,accounts.account,accounts.account.attributes,accounts.account.attributes.attribute,accounts.account.wallet,accounts.account.currency,accounts.account.currency.attributes,accounts.account.currency.attributes.attribute,accounts.account.product,accounts.account.product.attributes,accounts.account.product.attributes.attribute,accounts.account.product.type';

// const defaultWith = `roles,roles.role,status,${withPerson},${withAccount}`;
// const fullWith = `${defaultWith},${withPersonAddress}`;

const defaultPlatform = 6;
// const defaultLoginType = 5;

const AUTH_BASE_URL =
  env === 'development' && goLocal
    ? process.env.REACT_APP_AUTH_BASE_URL || 'http://localhost:64025'
    : process.env.REACT_APP_AUTH_BASE_URL;

const axiosOptions = {
  baseURL: AUTH_BASE_URL,
};
class Auth extends Base {
  constructor() {
    super('auth', AUTH_BASE_URL, axiosOptions);
  }

  login({ email, password }) {
    const options = {
      //   // url: `${this.basePath}/login?with=${fullWith}`,
      url: `${this.basePath}/login`,
      data: {
        idPlatform: defaultPlatform,
        payload: { email, password },
      },
    };
    return this.post(options);
    /* return P.resolve({
       user: { name: 'test rodriguez', id: '1' },
       accessToken: 'TOKEN',
       refreshToken: 'REFRESH_TOKEN',
     });*/
  }

  recoverPassword(user) {
    return P.resolve();
  }

  restoreSession({ token, refreshToken }) {
    // const options = {
    //   url: '/tokens/validate',
    //   data: { token, refreshToken },
    // };
    // return this.get(options);
    return P.resolve();
  }

  refreshToken(accessToken, refreshToken) {
    const options = {
      url: `/auth/tokens/refresh`,
      method: 'POST',
      data: {
        accessToken,
        refreshToken,
      },
    };
    return this.request(options);
  }
}

export default new Auth();
